import React, {ReactElement} from 'react';
import {Collapse} from 'react-collapse';
import {ReactComponent as IconDown} from 'assets/image/library/chevron-down.svg';
import {ReactComponent as IconUp} from 'assets/image/library/chevron-up.svg';
import cn from 'classnames';

import './styles.scss';

type CmFiltersProps = {
  children?: ReactElement | null;
  title: string
  expanded: boolean
  onClick: () => void
  disabled?: boolean
};

export const CmFilters = ({
  children, title, expanded, onClick, disabled
}: CmFiltersProps): JSX.Element => {
  const handleClick = () => {
    if (disabled) {
      return;
    }
    onClick();
  };

  return <div className="cm-filters">
    <button className={cn('cm-filters__header', disabled ? 'cm-filters__header--disabled' : '')} aria-expanded={expanded} onClick={handleClick}>
      <div className="cm-filters__title">
        {title}
      </div>
      {expanded ? !disabled && <IconUp className="cm-filters__arrow" /> : !disabled && <IconDown className="cm-filters__arrow" />}
    </button>
    <Collapse
      isOpened={expanded}>
      <div className="cm-filters__content">{children}</div>
    </Collapse>
  </div>;
};
